// Globals
import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { ChangeEvent } from 'react';

// Components
import { Button, Input } from '@/ui';
import { StyledButtons, StyledSearchWrapper, StyledTruncate } from '../components';
import { PenIcon, TrashIcon } from '@/icons';

// Models
import { IRedirect } from '@/models/redirect.model';

// Helpers
import { renderDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

export const redirectsColumns = (
  t: TFunction,
  searchValue = '',
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void,
  onDelete?: (record: IRedirect) => void,
  onEdit?: (record: IRedirect) => void,
): TableColumnsType<IRedirect> => [
  {
    dataIndex: 'code',
    key: 'code',
    width: 200,
    title: t('column_code'),
    render: (code: string) => <StyledTruncate>{code}</StyledTruncate>,
  },
  {
    dataIndex: 'source',
    key: 'source',
    width: 200,
    title: (
      <StyledSearchWrapper>
        <span>{t('column_source')}</span>
        <Input value={searchValue} onChange={onChange} size="small" placeholder={t('placeholder_search_redirect')} />
      </StyledSearchWrapper>
    ),
    render: (source: string) => <StyledTruncate>{source}</StyledTruncate>,
  },
  {
    dataIndex: 'target',
    key: 'target',
    width: 200,
    title: t('column_target'),
    render: (target: string) => <StyledTruncate>{target}</StyledTruncate>,
  },
  {
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200,
    title: t('label_created_at'),
    render: (target: string) => <StyledTruncate>{renderDate(target, DateFormats.DATE_WITH_TIME)}</StyledTruncate>,
  },
  {
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    width: 200,
    title: t('channel_table_columns_update_date'),
    render: (target: string) => <StyledTruncate>{renderDate(target, DateFormats.DATE_WITH_TIME)}</StyledTruncate>,
  },
  {
    title: t('column_action'),
    key: 'action',
    width: 150,
    render: (_, record) => (
      <StyledButtons>
        <Button
          icon={<PenIcon />}
          type="primary"
          size="small"
          block
          onClick={() => {
            onEdit?.(record);
          }}
        />
        <Button
          type="primary"
          size="small"
          icon={<TrashIcon />}
          danger
          block
          onClick={() => {
            onDelete?.(record);
          }}
        />
      </StyledButtons>
    ),
  },
];
